module.exports = __webpack_public_path__ + "static/media/9DESA29.f4109944.jpg";